module.exports = __webpack_public_path__ + "assets/default.8139efc4.svg";